import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

export const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBxJ3S_TWeXam868GCBtvxohGjtaQ4JkII',
  authDomain: 'dev-2026-core-project.firebaseapp.com',
  databaseURL: 'https://dev-2026-core-project-default-rtdb.firebaseio.com',
  projectId: 'dev-2026-core-project',
  storageBucket: 'dev-2026-core-project.firebasestorage.app',
  messagingSenderId: '596919312610',
  appId: '1:596919312610:web:00faf05159414e2bf97ebb'
})
export const firestore = firebaseApp.firestore()

const { Timestamp } = firebase.firestore
export { Timestamp }
